import { corporateAccountMenu } from '../../constants/menus/corporateAccountMenu';
import { individualAccountMenu } from '../../constants/menus/individualAccountMenu';
import { jointAccountMenu } from '../../constants/menus/jointAccountMenu';
import { retirementBusinessAccountMenu } from '../../constants/menus/retirementBusinessAccountMenu';
import { retirementPersonalAccountMenu } from '../../constants/menus/retirementPersonalAccountMenu';
import { trustAccountMenu } from '../../constants/menus/trustAccountMenu';
import { utmaAccountMenu } from '../../constants/menus/utmaAccountMenu';
import {
  APPLICATION_TYPE_STRING,
  CorporateAccountType,
  IRAAccountType,
} from '../constants';

export const getMenuByApplication = (applicationType, accountType) => {
  if (applicationType === APPLICATION_TYPE_STRING[1]) {
    return individualAccountMenu;
  }

  if (applicationType === APPLICATION_TYPE_STRING[4]) {
    return jointAccountMenu;
  }

  if (applicationType === APPLICATION_TYPE_STRING[5]) {
    return utmaAccountMenu;
  }

  if (applicationType === APPLICATION_TYPE_STRING[2]) {
    if (accountType === CorporateAccountType[4]) {
      return trustAccountMenu;
    }

    return corporateAccountMenu;
  }

  if (applicationType === APPLICATION_TYPE_STRING[3]) {
    if (
      accountType === IRAAccountType[1] ||
      accountType === IRAAccountType[2]
    ) {
      return retirementPersonalAccountMenu;
    }

    if (
      accountType === IRAAccountType[3] ||
      accountType === IRAAccountType[4]
    ) {
      return retirementBusinessAccountMenu;
    }
  }
};
